class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);

class PredictivePhrases extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll("button.predictive-phrase--item");
    this.searchForm = document.querySelector("#predictive-search-form input[type='search']");

    if(!this.buttons.length || !this.searchForm) return;
    this.buttons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        const value = event.currentTarget.dataset.value;
        this.searchForm.value = value;
        this.searchForm.dispatchEvent(new Event('input'));
      });
    });
  }
}

customElements.define("predictive-phrases", PredictivePhrases);

